import { render, staticRenderFns } from "./Modal-size.vue?vue&type=template&id=dc4b94c2&scoped=true&"
import script from "./Modal-size.vue?vue&type=script&lang=js&"
export * from "./Modal-size.vue?vue&type=script&lang=js&"
import style0 from "./Modal-size.vue?vue&type=style&index=0&id=dc4b94c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4b94c2",
  null
  
)

export default component.exports